<script lang="ts">
  import type {
    NflGameDataResponse,
    NflPlayByPlayResponse,
    NflStatKey,
  } from '@statmuse/core/gamera/index'
  import * as store from './stores'
  import { onMount } from 'svelte'
  import type { NflPlayersMediaQuery } from '@statmuse/core/../graphql/graphql'

  export let gameData: NflGameDataResponse<NflStatKey>
  export let playByPlay: NflPlayByPlayResponse
  export let players: Record<
    string,
    NonNullable<NflPlayersMediaQuery['nfl']['players']>[number] | undefined
  >

  onMount(() => {
    store.init({ gameData, playByPlay, players })
    // return () => store.gameState.set({})
  })
</script>
